export const HTTP_RESPONSE_CODE = {
    NO_CONTENT: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    CONFLICT: 409,
    SERVER_ERROR: 500,
    GATEWAY_TIMEOUT: 504,
};

export const HTTP_METHOD = {
    GET: 'get',
    POST: 'post',
    PUT: 'put',
};

export const API_KEYS = {
    RESULTS: 'results',
    STUDENT_STATUSES: 'studentStatuses',
    STUDENT_GROWTH_ZONES: 'studentGrowthZones',
    FORMS: 'forms',
    CUTSCORES: 'cutscores',
    REMINDERS: 'reminders',
    INSTRUCTIONS: 'instructions',
    CLPL_CUTSCORES: 'clplCutscores',
    CLPL_FORMS: 'clplForms',
};
